import _ from 'lodash'

class Enum
{
  static init(values, labels, options) {
    this.__map = values;
    this.__labels = labels;
    this.__options = options || {};

    _.map(this.__map, (v, k) => {
      this[k] = v;
    });
  }

  static values() {
    return Object.values(this.__map).map(k => new this(k));
  }

  static [Symbol.iterator]() {
    const map = this.__map;

    return {
      next: function() {
        if (this.index < map.length) {
          return { done: false, value: map[this.index++]}
        }
        return { done: true }
      },
      index: 0
    }
  }

  static label(name) {
    return this.__labels[name];
  }

  static get options() {
    const allOptions = _.map(this.__map, (v,k) => ({
      id: v,
      name: _.has(this.__labels, k) ? this.__labels[k] : v
    }));

    const customOptions = _.reduce(this.__options, (acc, v, k) => {
      acc[k] = v.map(field => ({
        id: this.__map[field],
        name: this.__labels[field]
      }));
      return acc;
    }, {});

    const result = {
      all: allOptions,
      ...customOptions
    };

    return result;
  }

  constructor(value) {
    this.__item = _.findKey(this.constructor.__map, (s) =>  s === value);
    this.__value = value;

    if (this.__item) {
      Object.defineProperty(this, this.__item, {
        enumerable: true,
        get: () => true
      });
    }
  }

  toString() {
    return this.__item;
  }

  get valid() {
    return !!this.__item;
  }

  get label() {
    return _.get(this.constructor.__labels, this.__item, '-');
  }

  valueOf() {
    return this.__value;
  }
}

export default Enum;

